import React, { useState } from 'react';

const SpotlightEffect = ({ 
  timestamp, 
  seconds, 
  currentTime, 
  position = { top: '20%', left: '50%' }, 
  duration = 2,
  effectType = 'spotlight',
  modalContent = {
    title: "Moment Detail",
    image: "https://via.placeholder.com/600x400?text=Book+Excerpt+Image",
    description: "This moment represents a key turning point in the performance."
  },
  videoControls
}) => {
  const [showModal, setShowModal] = useState(false);
  
  // Only show the spotlight during a specific time window (configurable duration)
  const isVisible = currentTime >= seconds && currentTime < seconds + duration;
  
  if (!isVisible) {
    return null;
  }
  
  const handleClick = () => {
    // Pause the video when opening the modal
    if (videoControls) {
      videoControls.pause();
    }
    setShowModal(true);
  };
  
  const closeModal = () => {
    // Resume playback when closing the modal
    if (videoControls) {
      videoControls.play();
    }
    setShowModal(false);
  };
  
  return (
    <>
      <div 
        className={`effect cursor-pointer ${effectType === 'halo' ? 'halo-effect' : 'spotlight-effect'}`}
        style={{
          position: 'absolute',
          top: position.top,
          left: position.left,
          transform: 'translate(-50%, -50%)',
          width: effectType === 'halo' ? '60px' : '80px',
          height: effectType === 'halo' ? '60px' : '80px',
          borderRadius: '50%',
          background: effectType === 'halo' 
            ? 'radial-gradient(circle, rgba(255,215,0,0.8) 0%, rgba(255,215,0,0.4) 40%, rgba(255,215,0,0) 70%)'
            : 'radial-gradient(circle, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0) 70%)',
          animation: effectType === 'halo' ? 'glow 1.5s infinite' : 'pulse 2s infinite',
          boxShadow: effectType === 'halo' ? '0 0 15px 5px rgba(255,215,0,0.5)' : 'none',
          zIndex: 15
        }}
        onClick={handleClick}
        title="Click to view details"
      />
      
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg max-w-lg w-full">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-xl font-semibold text-white">{modalContent.title}</h3>
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-white"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="mb-4">
              <img 
                src={modalContent.image} 
                alt={modalContent.title} 
                className="w-full rounded"
              />
            </div>
            
            <p className="text-gray-300 mb-4">
              {modalContent.description}
            </p>
            
            {modalContent.referenceLink && (
              <div className="mb-4">
                <button 
                  onClick={() => {
                    // Open the reference in a new window/tab
                    window.open(modalContent.referenceLink, '_blank');
                  }}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                >
                  Show Reference
                </button>
              </div>
            )}
            
            <div className="flex justify-end">
              <button
                onClick={closeModal}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SpotlightEffect;
